import { Stack, IconButton, Tooltip } from '@mui/material';
import { UploadFile, Preview } from '@mui/icons-material';
import { ModalsKeys } from 'global';
import { useModal } from 'hooks/useModal';

interface Props {
  equipmentId?: string;
  onImagesSaved?: (files: File[]) => void;
}

export const EquipmentImageActions = ({ equipmentId, onImagesSaved }: Props) => {
  const { handleOpen: handleOpenUploadImagesDialog } = useModal(
    equipmentId ? ModalsKeys.UploadImagesForExistingEquipmentDialog : ModalsKeys.UploadImagesForNewEquipmentDialog
  );

  const { handleOpen: handleOpenPreviewImagesDialog } = useModal(ModalsKeys.PreviewExistingEquipmentImagesDialog);

  return (
    <Stack direction="row" gap="0.5rem">
      <Tooltip title="Upload Equipment Images">
        <IconButton
          color="primary"
          size="small"
          onClick={() => {
            if (equipmentId) {
              handleOpenUploadImagesDialog({ equipmentId });
            } else {
              handleOpenUploadImagesDialog({
                onSave: (files: File[]) => {
                  onImagesSaved?.(files);
                },
              });
            }
          }}
        >
          <UploadFile />
        </IconButton>
      </Tooltip>

      <Tooltip title="Preview Equipment Images">
        <IconButton
          color="primary"
          size="small"
          disabled={!equipmentId}
          onClick={() => {
            if (equipmentId) {
              handleOpenPreviewImagesDialog({ equipmentId });
            }
          }}
        >
          <Preview />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};
